import DropdownMenu from '../../components/navigation/dropdownMenu';

[...document.querySelectorAll('.l-site-nav')].forEach((siteNav) => {
  new DropdownMenu({ navigation: siteNav }).mount();
});
